// extracted by mini-css-extract-plugin
module.exports = {"title":"Footer-Title-module--title--39-jL"};